module.exports = __webpack_public_path__ + "img/a-usa.51e6d0c7.svg";